// extracted by mini-css-extract-plugin
export default {"main":"styles_main__HzdrX","container2":"styles_container2__9wQYx","events":"styles_events__2onye","event_container":"styles_event_container__gmWHH"};